import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import * as constants from "Constants";
// import httpService from 'services/httpService.js';
import { Alert, Spinner } from "react-bootstrap";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import displayGlobalMessage from "Utils/DisplayGlobalMessage";
// import { toast } from "react-toastify";
import { FcExpired } from "react-icons/fc";
import { MdDoneAll, MdOpenInNew } from "react-icons/md";
import OnReloadFullScreenLoader from "Components/OnReloadFullScreenLoader";
import ConfirmationModal from "./Components/SubmitQuizView/ConfirmationModal";
import TopInfoBox from "./Components/SubmitQuizView/TopInfoBox";
import StudentFiles from "./Components/SubmitQuizView/StudentFiles";
import QuizTimeLeft from "./Components/SubmitQuizView/QuizTimeLeft";
import QuestionsNavigation from "./Components/SubmitQuizView/QuestionsNavigation";
import QuestionsList from "./Components/SubmitQuizView/QuestionsList";
import log from "loglevel";
import httpService from "services/httpService";

const OtherActivity = ({
  otherActivityDetails,
  labAvailableTill,
  labId,
  urlFrom,
  isExam
}) => {

  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const studentUserinfo = useSelector(state => state?.userInfo?.username);
  const userId = useSelector((state) => state.userInfo.userId);

  const { courseId, activityID } = params;

  const [otherActivityData, setOtherActivityData] = useState(otherActivityDetails);
  const [labAvailableTime, setLabAvailableTill] = useState(labAvailableTill ? labAvailableTill : (location.labData ? location.labData.available_till : null));

  const [relatedClabActivity, setRelatedClabActivity] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const [autoSubmit, setAutoSub] = useState(false);
  const [showFullScreenLoader, setShowFullScreenLoader] = useState(true);

  useEffect(() => {
    if (otherActivityData && isExam) {
      setShowFullScreenLoader(false);
    } else {
      if (otherActivityData && labAvailableTime) setShowFullScreenLoader(false);
    }
  }, [otherActivityData]);

  const [student_name, setStudentName] = useState("");
  const [student_email, setStudentEmail] = useState("");

  const [studentFiles, setStudentFiles] = useState([]);
  const [showStudentFilesModal, setShowStudentFilesModal] = useState(false);
  const [activity_evaluated, setActivityEvaluated] = useState(false);

  const [isDataFetching, setIsDataFetching] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [labExpired, setIsLabExpired] = useState(false);
  const [millisecondsLeft, setMilliSecondsLeft] = useState(0);

  const questionRefs = useRef([]);

  useEffect(() => {
    if (labExpired || isSubmitted || isDataFetching || isSubmitting) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [labExpired, isSubmitted, isSubmitting, isDataFetching]);

  useEffect(() => {
    if (labAvailableTime) {
      let till = moment(labAvailableTime);
      let now = moment();
      log.log({ labAvailableTime: now.isAfter(till) })
      if (now.isAfter(till)) {
        setIsLabExpired(true);
      } else {
        setIsLabExpired(false);
      }
    }
    log.log({ labAvailableTime })
  }, [labAvailableTime]);

  const fetchClabActivity = async (clabActId) => {
    if (!clabActId) return;
    try {
      const response = await httpService.get(`${constants.base_url}/clab/activity/${clabActId}/`);
      if (response && response.data) {
        setRelatedClabActivity(response.data);
      } else {
        setRelatedClabActivity(null);
      }
    } catch (error) {
      console.error('Error fetching related cLab activity:', error);
      setRelatedClabActivity(null);
    }
  };

  useEffect(() => {
    log.log("other activity Student Side", labAvailableTill);
    log.log("okk", labId);
    log.log("okk", otherActivityData);

    const fetchActivityDetails = async (activityID) => {
      const response = await httpService.get(`${constants.base_url}/lab/activity/${activityID}?type=other`);
      const activityData = response.data?.other_activity;

      setOtherActivityData(activityData);

      if (Array.isArray(activityData?.requiredfiles_set)) {
        setStudentFiles(activityData.requiredfiles_set.map((file) => ({ ...file, isUploaded: true })));
      }
    };

    const fetchOtherActivityDetails = async () => {
      if (!otherActivityDetails.is_published) {
        navigate("/"); // Redirect to home page if not published
        return;
      }

      setOtherActivityData(otherActivityDetails);
      setActivityEvaluated(otherActivityDetails?.evaluated || false);
      setLabAvailableTill(otherActivityDetails?.lab_data?.available_till || null);
      setMilliSecondsLeft(otherActivityDetails?.lab_data?.time_left || 0);
      // fetchClabActivity(otherActivityDetails?.virtualActivity);

      if (Array.isArray(otherActivityDetails?.requiredfiles_set)) {
        setStudentFiles(otherActivityDetails.requiredfiles_set.map((file) => ({ ...file, isUploaded: true })));
      }
    };

    const fetchStudentData = async (activityID, studentUserinfo) => {
      const url = `${constants.base_url}/otherlabs/activity/${activityID}/other_activity_submissions/${studentUserinfo}/`;
      const response = await httpService.get(url);
      const responseData = response.data.data?.[studentUserinfo];

      if (responseData) {
        const updatedActivity = { ...otherActivityDetails };

        if (updatedActivity.question_set?.length > 0) {
          updatedActivity.question_set.forEach((question) => {
            const matchingResponse = responseData?.responses?.find((item) => item.question === question.id);
            if (matchingResponse) question.questionresponse_set = matchingResponse;
          });
          setIsSubmitted(true);
          setOtherActivityData(updatedActivity);
          setIsSubmitting(true);
        } else {
          setIsSubmitted(!!responseData.submitted);
        }
      } else {
        setIsSubmitted(false);
      }
    };

    const fetchUserProfile = async (userId) => {
      const response = await httpService.get(`/accounts/api/profile/?user=${userId}`);
      const profile = response.data.find((p) => p.user === userId);
      if (profile) {
        setStudentEmail(profile.email);
        setStudentName(`${profile.first_name} ${profile.last_name}`);
      }
    };

    const fetchData = async () => {
      try {
        setIsDataFetching(true);
    
        if (activityID) await fetchActivityDetails(activityID);
        if (otherActivityDetails) await fetchOtherActivityDetails();
        await fetchStudentData(activityID, studentUserinfo);
        await fetchUserProfile(userId);
    
      } catch (error) {
        log.error("Error fetching data:", error);
      } finally {
        setIsDataFetching(false);
      }
    };

    // const fetchData = async () => {
    //   try {
    //     setIsDataFetching(true);
    //     if (activityID) {
    //       const response = await httpService.get(constants.base_url + "/lab/activity/" + activityID + "?type=other");
    //       log.log("Activity Response Details ", response, response.data?.other_activity?.lab_data?.available_till);
    //       setOtherActivityData(response.data?.other_activity);
    //       if (Array.isArray(response.data.other_activity?.requiredfiles_set)) {
    //         setStudentFiles(response.data.other_activity?.requiredfiles_set?.map(r => ({ ...r, isUploaded: true })));
    //       }
    //     }
    //     if (otherActivityDetails) {
    //       if (!otherActivityDetails.is_published) {
    //         log.log("home page")
    //         navigate("/"); // Redirect to home page if not published
    //         return;
    //       }
    //       setOtherActivityData(otherActivityDetails);
    //       setActivityEvaluated(otherActivityDetails?.evaluated || false);
    //       if (otherActivityDetails?.lab_data?.available_till) {
    //         setLabAvailableTill(otherActivityDetails.lab_data.available_till);
    //       }
    //       if (otherActivityDetails?.lab_data?.time_left) {
    //         setMilliSecondsLeft(otherActivityDetails.lab_data.time_left);
    //       }
    //       if (Array.isArray(otherActivityDetails?.requiredfiles_set)) {
    //         setStudentFiles(otherActivityDetails?.requiredfiles_set?.map(r => ({ ...r, isUploaded: true })));
    //       }

    //       const base_other_activity_submissions_url = `${constants.base_url}/otherlabs/activity/${activityID}/other_activity_submissions`
    //       const students_data_url = `${base_other_activity_submissions_url}/${studentUserinfo}/`;

    //       const response = await httpService.get(students_data_url);
    //       const responseData = response.data.data?.[studentUserinfo];
    //       if (responseData) {
    //         const updatedOtherActivityDetails = { ...otherActivityDetails };
    //         let updated = false; // Flag to track if otherActivityDetails has been updated
    //         log.log({ updatedOtherActivityDetails, responseData });
    //         if (updatedOtherActivityDetails.question_set.length > 0) {
    //           for (let i = 0; i < updatedOtherActivityDetails?.question_set?.length; i++) {
    //             const question = updatedOtherActivityDetails.question_set[i];
    //             log.log("okkkk question ", question.id);

    //             // Find the matching response data for this question
    //             const matchingResponse = responseData?.find?.(item => item.question === question.id);

    //             if (matchingResponse) {
    //               // Replace questionresponse_set with matching response data
    //               question.questionresponse_set = matchingResponse;
    //               log.log("okkkk matches ", question.id, question);
    //               updated = true;
    //             }
    //             setIsSubmitted(true);
    //           }
    //         } else {
    //           // if ()
    //           const submittedResponse = responseData?.submitted;
    //           setIsSubmitted(submittedResponse);
    //         }

    //         // Only update otherActivityDetails if it has been modified
    //         log.log("okkkk updated ", updated);
    //         if (updated) {
    //           setOtherActivityData(updatedOtherActivityDetails);
    //           log.log("okkkk data", updatedOtherActivityDetails);
    //           log.log("okkk updated data", updatedOtherActivityDetails);
    //           setIsSubmitting(true);
    //         } else {
    //           log.log("okkkk matches", 0);
    //         }
    //       } else {
    //         setIsSubmitted(false);
    //       }
    //     }
    //     const user_resp = await httpService.get(`/accounts/api/profile/?user=${userId}`);
    //     const profiles = user_resp.data;
    //     let this_profile = profiles?.find(f => f.user === userId);
    //     setStudentEmail(this_profile?.email);
    //     setStudentName(this_profile?.first_name + " " + this_profile?.last_name);
    //     log.log("current user : ", student_email, student_name)
    //   } catch (error) {
    //     log.log(error);
    //   } finally {
    //     setIsDataFetching(false);
    //   }
    // };

    fetchData();
  }, [labId, otherActivityDetails]);

  const handleCloseStudentFilesModal = () => {
    setShowStudentFilesModal(false);
  }

  const handleOpenStudentFilesModal = () => {
    setShowStudentFilesModal(true);
  }

  const handleConfirmSubmission = async () => {
    setShowModal(false);
    setIsSubmitting(true);

    const url = `${constants.base_url}/otherlabs/activity/${activityID}/student_submission/`;

    try {
      const response = await httpService.post(url, otherActivityData, {
        params: {
          stud_id: student_email,
          username: student_name,
        },
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 200 && response.data?.success) {
        setIsSubmitted(true);
        setShowFullScreenLoader(true);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else if (response.status === 200 && !response.data?.success) {
        displayGlobalMessage("Failed to Submit. Error occurred while saving your submission.", "error");
      } else {
        log.log("Non-success response:", response);
        displayGlobalMessage("Error submitting", "error");
      }
    } catch (error) {
      log.error("Error response:", error);
      displayGlobalMessage("Submission failed!", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmit = () => {
    if (autoSubmit) {
      handleConfirmSubmission();
      return;
    }

    const missingCount = otherActivityData.required_files_num - studentFiles.length;
    if (missingCount > 0) {
      displayGlobalMessage(`Please add ${missingCount} file(s) before submitting`, "error");
      return;
    }

    if (!isSubmitted) {
      handleShowModal();
    } else {
      displayGlobalMessage("Already submitted!", "info");
    }
  };

  return (
    <>
      <OnReloadFullScreenLoader customLoaderValue={showFullScreenLoader} />

      {(isDataFetching) ? <>
        <div style={{ margin: "10px" }}>
          <div className="d-flex gap-2 justify-content-center align-items-center">
            <Spinner size="sm" animation="border" />
          </div>
        </div>

      </> : <></>}

      {(labExpired) ? <>
        <Alert variant={"danger"} className="py-5" style={{ marginLeft: "10px", marginRight: "10px" }}>
          <div className="d-flex gap-2 justify-content-center align-items-center">
            <FcExpired size={28} />
            <span>This Lab has expired.</span>
          </div>
        </Alert>
      </> : <></>}

      {(isSubmitted && !isDataFetching) ? <>
        <Alert variant={"info"} className="py-5" style={{ marginLeft: "10px", marginRight: "10px" }}>
          <div className="d-flex gap-2 justify-content-center align-items-center">
            <MdDoneAll size={28} />
            <span>You have submitted.</span>
          </div>
        </Alert>
      </> : <></>}

      {/* {(otherActivityDetails?.virtualActivity && !isDataFetching) ? <>
        <Alert variant={"warning"} className="py-5" style={{ marginLeft: "10px", marginRight: "10px" }}>
          <div className="d-flex gap-2 justify-content-center align-items-center">
            <p>Attempt <span style={{fontWeight: 'bold'}}>{relatedClabActivity?.name || "activity"}</span> on 
            <a href={`clab://#/course/${courseId}/lab/${labId}/activity/${relatedClabActivity?.id}`} target="_blank">
              cLab app.
              <span>
                <MdOpenInNew size={20} />
              </span>
            </a>
            </p>
          </div>
        </Alert>
      </> : <></>} */}

      <div style={{ display: "flex", height: "100%", marginLeft: "10px", marginRight: "10px" }}>
        <div style={{ flex: "1 1 78%", paddingRight: "20px", overflowY: "auto" }}>
          <TopInfoBox
            otherActivityDetails={otherActivityDetails}
            otherActivityData={otherActivityData}
            activity_evaluated={activity_evaluated}
          />

          {/* {log.log(" evaluated ", activity_evaluated, isDisabled)} */}
          <QuestionsList
            questionRefs={questionRefs}
            activity_evaluated={activity_evaluated && isSubmitted}
            labId={labId}
            otherActivityData={otherActivityData}
            setOtherActivityData={setOtherActivityData}
            isDisabled={isDisabled}
            labAvailableTime={labAvailableTime}
          />
          {
            otherActivityData?.required_files_num > 0 ?
              <StudentFiles
                otherActivityData={otherActivityData}
                showStudentFilesModal={showStudentFilesModal}
                handleCloseStudentFilesModal={handleCloseStudentFilesModal}
                handleOpenStudentFilesModal={handleOpenStudentFilesModal}
                studentFiles={studentFiles}
                isDisabled={isDisabled}
                setStudentFiles={setStudentFiles}
                student_email={student_email}
                student_name={student_name}
              /> : <></>
          }
        </div>

        <div style={{ flex: "1 1 22%", borderLeft: "0px solid #ccc", position: "sticky", top: 0, height: "20vh", zIndex: 1 }}>
          <QuizTimeLeft
            isDisabled={isDisabled}
            labAvailableTime={labAvailableTime}
            labExpired={labExpired}
            millisecondsLeft={millisecondsLeft}
            setAutoSub={setAutoSub}
            setIsLabExpired={setIsLabExpired}
          />
          <QuestionsNavigation
            questionRefs={questionRefs}
            otherActivityData={otherActivityData}
          />
          {!isDisabled && <div>
            <button
              id="submitButton"
              style={{
                backgroundColor: isSubmitting ? '#fff' : 'white',
                border: isSubmitting ? 'solid 2px #ccc' : 'solid 2px #1ECD97',
                color: isSubmitting ? '#ccc' : '#1ECD97',
                width: '220px',
                height: isSubmitting ? '60px' : '60px',
                fontSize: '18px',
                fontWeight: 'bold',
                borderRadius: '30px',
                cursor: 'pointer',
                transition: 'background-color 0.4s ease',
                position: 'relative',
              }}
              onClick={handleSubmit}
              disabled={isSubmitting || isDisabled || isDataFetching}
            >
              {
                isSubmitting ? "Submitting..." : "Submit"
              }
            </button>
          </div>}
        </div>
      </div>

      <ConfirmationModal show={showModal} onClose={handleCloseModal} onConfirm={handleConfirmSubmission} />
    </>
  );
}


export default OtherActivity;
